/* Eager full-collection loading for grids (#product-grid + #Huratips-Pagination).
   Progressive enhancement over the server-rendered "Load More" link: once the
   browser is idle after initial render, every remaining page is fetched in the
   background and its grid items appended, so the whole collection is in the
   DOM before the shopper reaches the end (images stay lazy). The link keeps
   working as a plain paginator without JS, and the IntersectionObserver on the
   sentinel remains as a retry path if a background fetch fails.
   Facets (facets.js) replace #ProductGridContainer's innerHTML on filter/sort,
   so setup re-arms on the fresh nodes via a MutationObserver on the container.
   After each append a `sl:grid:append` event fires so card state that is
   synced once per page (Swym wishlist hearts) can re-sync. */
(function () {
  if (window.__slInfiniteScroll) return;
  window.__slInfiniteScroll = true;

  var OFFSET_PX = 1400;

  function setup(root) {
    var pagination = root.querySelector('#Huratips-Pagination');
    var grid = root.querySelector('#product-grid');
    if (!grid || !pagination || pagination.dataset.slInfinite === '1') return;
    pagination.dataset.slInfinite = '1';

    /* With a section id the Section Rendering API returns just this section's
       HTML (~1/3 of the full page) — much faster to render and parse. */
    var sectionId = grid.getAttribute('data-id') || '';
    var loading = false;

    function nextLink() {
      return pagination.querySelector('a[href]');
    }

    function fetchDoc(url, useSection) {
      var target = url;
      if (useSection && sectionId) {
        target = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);
      }
      return fetch(target)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          if (!doc.getElementById('product-grid') && useSection && sectionId) {
            return fetchDoc(url, false);
          }
          return doc;
        });
    }

    function loadNext() {
      var link = nextLink();
      if (!link || loading) return;
      loading = true;
      link.textContent = 'Loading...';
      fetchDoc(link.href, true)
        .then(function (doc) {
          var newGrid = doc.getElementById('product-grid');
          var newPag = doc.getElementById('Huratips-Pagination');
          if (newGrid) {
            while (newGrid.firstElementChild) grid.appendChild(newGrid.firstElementChild);
          }
          pagination.innerHTML = newPag ? newPag.innerHTML : '';
          loading = false;
          document.dispatchEvent(new CustomEvent('sl:grid:append'));
          if (nextLink()) loadNext();
        })
        .catch(function () {
          loading = false;
          var retry = nextLink();
          if (retry) retry.textContent = 'Load More';
        });
    }

    pagination.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (!a) return;
      e.preventDefault();
      loadNext();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) loadNext();
        });
      }, { rootMargin: OFFSET_PX + 'px 0px' }).observe(pagination);
    }

    /* Eager kick-off: wait for the browser to go idle so the initial render
       keeps priority, then chain-load the rest of the collection. */
    if ('requestIdleCallback' in window) {
      requestIdleCallback(loadNext, { timeout: 2000 });
    } else {
      setTimeout(loadNext, 800);
    }
  }

  function init() {
    var container = document.getElementById('ProductGridContainer');
    setup(container || document);
    if (container) {
      new MutationObserver(function () { setup(container); })
        .observe(container, { childList: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
